import React from "react";
import PageHero from "../components/PageHero";
import { company } from "../mock";

export default function ComplianceDisclaimer() {
  return (
    <main>
      <PageHero
        eyebrow="Legal"
        title="Compliance Disclaimer"
        subtitle="Important information about the nature of our consultancy services and the boundaries between consultancy support and independent external audit."
        breadcrumb={[{ label: "Compliance Disclaimer" }]}
      />

      <section className="py-16 md:py-20">
        <div className="container-x max-w-4xl">
          <div className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
            <p className="text-sm text-slate-500">Last updated: 2026</p>

            <h2 className="text-2xl font-bold text-navy mt-8">1. Nature of our services</h2>
            <p>
              Apex Quality Consultancy provides consultancy, internal audit and compliance preparation services for
              NDIS providers. Our support is informed by practical audit experience, NDIS Practice Standards knowledge
              and real audit evidence expectations.
            </p>
            <p>
              We are not an Approved Quality Auditor and we do not perform independent external audits for providers
              we have consulted to. Our consultancy work is separate from independent external audit services. This
              separation protects impartiality and avoids conflicts of interest.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">2. No guarantee of outcome</h2>
            <p>
              Apex Quality Consultancy does not guarantee:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>NDIS registration</li>
              <li>Audit approval or audit outcomes</li>
              <li>Acceptance of documentation by external auditors</li>
              <li>Participant referrals or client numbers</li>
            </ul>
            <p>
              Audit and registration outcomes depend on the provider’s implementation, staff qualifications, evidence,
              business operations, participant records, application accuracy and auditor assessment.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">3. Working with accredited NDIS auditors</h2>
            <p>
              Where required, we work closely with accredited NDIS auditors and experienced compliance professionals.
              We maintain clear separation between consultancy support and independent external audit services in all
              engagements.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">4. General information only</h2>
            <p>
              Information provided by Apex Quality Consultancy, including website content, documentation, templates,
              guidance notes, articles and consultation discussions, is general consultancy and compliance preparation
              support only. It is not legal, financial, accounting or insurance advice. Providers should obtain
              independent professional advice where required.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">5. Provider responsibility</h2>
            <p>
              While we provide documentation, guidance and audit readiness support, the provider remains responsible
              for:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Implementing policies and procedures into actual service delivery</li>
              <li>Maintaining accurate records, registers and participant documentation</li>
              <li>Worker screening, training and qualifications</li>
              <li>Insurance, ASIC, government and external auditor fees</li>
              <li>Application accuracy and submission</li>
              <li>Operational decisions and ongoing compliance</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mt-8">6. Australian Consumer Law</h2>
            <p>
              Nothing in this disclaimer or in our Terms of Service limits, restricts or modifies any rights or
              remedies available to you under the Australian Consumer Law that cannot lawfully be excluded.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">7. Contact us</h2>
            <p>
              If you have any questions about this disclaimer, contact us at
              {' '}<a href={`mailto:${company.email}`} className="text-teal underline">{company.email}</a> or call {company.phone}.
            </p>

            <div className="mt-10 p-5 bg-mist rounded-xl border border-slate-200 text-sm">
              <p className="font-semibold text-navy">{company.legalName}</p>
              <p>ABN: {company.abn} | ACN: {company.acn}</p>
              <p>{company.address}</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
